import { useMutation } from "@tanstack/react-query";
import axios from "axios";

const uploadFiles = async (data) => {
  const { clientId, projectId, folder, files, amended } = data;

  console.log("UPLOAD FILES DATA: ", data);

  const uploadPromises = files.map((file) => {
    return axios.postForm(
      `/api/upload-file/${clientId}/${projectId}/${folder}/`,
      {
        file: file,
        fileName: file.name,
        amended: amended || false,
      },
      { withCredentials: true },
    );
  });

  return Promise.all(uploadPromises);
};

export const useUploadFiles = (projectId, queryClient) => {
  return useMutation({
    mutationFn: uploadFiles,
    onError: (err) => console.error("UPLOAD FILES ERROR", err),
    onSuccess: (data) => console.log("UPLOAD FILES SUCCESS", data),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ["uploaded-project-files", projectId],
      });
      queryClient.invalidateQueries({
        queryKey: ["required-project-files", projectId],
      });
    },
  });
};
